import React, { useContext, useState } from 'react';
import Layout from "../../components/global/Layout";
import { ICONS } from "../../theme"
import { _auth, Notification } from '../../services/api';
import { AuthContext } from '../../context';
import { useLocation, Link, useHistory, Redirect } from "react-router-dom";
import Button from '@mui/material/Button';
import { CONFIG } from "../../config";

const useQuery = () => new URLSearchParams(useLocation().search);

function Home() {
  const [isLoading, setLoading] = React.useState(false);
  const context = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const history = useHistory();
  let query = useQuery();

  const validateUser = async () => {
    const appuser_ID = query.get('appuser_ID');
    const token = query.get('token');
    const page = query.get('p');
    const scan_type = query.get('scan_type');
    const facility_id = query.get('facility_id');

    if ((appuser_ID && token)) {
      context.logout();
      setLoading(true);
      try {
        const res = await _auth.validateUser({ appuser_ID, token, scan_type, facility_id });
        if (res?.success) {
          history.push(page === 'face-scan' ? '/face-scan' : '/face-gallery')
          const obj = {
            ...res.data,
            ...{
              user: {
                scan_type,
                facility_id,
                first_name: res.data.user.first_name,
                lastLogin: res.data.user.lastLogin,
                last_name: res.data.user.last_name,
                user_id: res.data.user.user_id,
              }
            }
          };
          context.login(obj);
        } else {
          history.replace({});
          Notification('Not Authorized', res?.message, 'danger')
        }
      } catch (error) { }
      setLoading(false);
    }
  };


  const goToALiv = () => {
    window.open(`${CONFIG.ALIV_URL}/Login?face-scan`, "_self");
  }
  React.useEffect(() => { validateUser() }, [])

  return (
    <Layout styleId="home-page">
      {isLoading && !user ? (
        <div className='center-absolute'>
          <img src={ICONS.LoaderIcon} alt="" />
          <h6>Please wait</h6>
        </div>
      ) : (user ? (
        <>
          <div className="center-absolute">
            <div className="redirect-btns">
              <Button component={Link} to="/face-gallery" variant="contained">Face Gallery</Button>
              <Button component={Link} to="/face-scan" variant="contained" disabled={!user?.scan_type || !user?.scan_type} >Mark Attendance</Button>
            </div>
            {(!user?.scan_type || !user?.scan_type) &&
              <div className="disabled-msg">
                <h6>Face attendance functionality is currently disabled.</h6>
                <h6>Please use alive dashboard link for Attendance.</h6>
              </div>
            }

          </div>
        </>
      ) : (
        <div className='center-absolute'>
          <img src={ICONS.Forbidden} alt="" />
          <h6>Please login with your Aliv account</h6>
          <Button variant="contained" onClick={goToALiv} >
            Login
          </Button>
        </div>
      ))
      }
    </Layout>
  );
}

export default Home;
